// extracted by mini-css-extract-plugin
module.exports = {"m--date-text":"DateText_m--date-text__Ryz7t","m--symbol":"DateText_m--symbol__Xg42o","m--value":"DateText_m--value__QSzja"};